/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClassificationType } from '../../models/classification-type';
import { DemoAccountDataExportCto } from '../../models/demo-account-data-export-cto';

export interface ExportDemoAccountDataAsync$Plain$Params {
  demoDataType: ClassificationType;
  documentId?: string;
}

export function exportDemoAccountDataAsync$Plain(http: HttpClient, rootUrl: string, params: ExportDemoAccountDataAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoAccountDataExportCto>> {
  const rb = new RequestBuilder(rootUrl, exportDemoAccountDataAsync$Plain.PATH, 'get');
  if (params) {
    rb.path('demoDataType', params.demoDataType, {});
    rb.query('documentId', params.documentId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DemoAccountDataExportCto>;
    })
  );
}

exportDemoAccountDataAsync$Plain.PATH = '/demo-account-data/{demoDataType}/export';
